import { Navigate, Route, Routes } from "react-router";
import { useAuth } from "./auth.js";
import { Layout } from "./components/Layout.js";
import { Login } from "./routes/Login.js";
import { Customers } from "./routes/Customers.js";
import { CustomerDetail } from "./routes/CustomerDetail.js";
import { NewConfig } from "./routes/NewConfig.js";
import { SealSecrets } from "./routes/SealSecrets.js";
import { Monitoring } from "./routes/Monitoring.js";
import { Releases } from "./routes/Releases.js";
import { Users } from "./routes/Users.js";
import { Plans } from "./routes/Plans.js";
import { LlmModels } from "./routes/LlmModels.js";
import { SystemPrompts } from "./routes/SystemPrompts.js";
import { Usage } from "./routes/Usage.js";
import { AuditLog } from "./routes/AuditLog.js";
import { LicenseSwaps } from "./routes/LicenseSwaps.js";
import { Errors } from "./routes/Errors.js";
import { Conversations } from "./routes/Conversations.js";
import { ConversationDetail } from "./routes/ConversationDetail.js";

export function App() {
  const { token } = useAuth();
  if (!token) return <Login />;
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/customers" element={<Customers />} />
        <Route path="/customers/:id" element={<CustomerDetail />} />
        <Route path="/customers/:id/configs/new" element={<NewConfig />} />
        <Route path="/customers/:id/machines/:machineId/seal" element={<SealSecrets />} />
        <Route path="/plans" element={<Plans />} />
        <Route path="/llm-models" element={<LlmModels />} />
        <Route path="/system-prompts" element={<SystemPrompts />} />
        <Route path="/usage" element={<Usage />} />
        <Route path="/audit-log" element={<AuditLog />} />
        <Route path="/license-swaps" element={<LicenseSwaps />} />
        <Route path="/monitoring" element={<Monitoring />} />
        <Route path="/errors" element={<Errors />} />
        <Route path="/conversations" element={<Conversations />} />
        <Route path="/conversations/:id" element={<ConversationDetail />} />
        <Route path="/releases" element={<Releases />} />
        <Route path="/users" element={<Users />} />
        <Route path="*" element={<Navigate to="/customers" replace />} />
      </Route>
    </Routes>
  );
}
